import React from 'react';
export default function EmptyAvatar() {
  return React.createElement("svg", {
    width: '34',
    height: '34',
    viewBox: '0 0 75 75',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement("g", {
    clipPath: 'url(#clip0_1369_28173)'
  }, React.createElement("rect", {
    width: '75',
    height: '75',
    rx: '37.5',
    fill: 'url(#paint0_linear_1369_28173)'
  }), React.createElement("rect", {
    width: '75',
    height: '75',
    rx: '37.5',
    fill: 'url(#paint1_radial_1369_28173)',
    fillOpacity: '0.7'
  }), React.createElement("rect", {
    width: '75',
    height: '75',
    rx: '37.5',
    fill: 'url(#paint2_radial_1369_28173)',
    fillOpacity: '0.3'
  })), React.createElement("defs", null, React.createElement("linearGradient", {
    id: 'paint0_linear_1369_28173',
    x1: '9.43709',
    y1: '9.52135',
    x2: '64.7763',
    y2: '60.7731',
    gradientUnits: 'userSpaceOnUse'
  }, React.createElement("stop", {
    stopColor: '#7701BB'
  }), React.createElement("stop", {
    offset: '0.0745527',
    stopColor: '#7601BB'
  }), React.createElement("stop", {
    offset: '0.146751',
    stopColor: '#7503BC'
  }), React.createElement("stop", {
    offset: '0.216879',
    stopColor: '#7205BD'
  }), React.createElement("stop", {
    offset: '0.285219',
    stopColor: '#6E09BF'
  }), React.createElement("stop", {
    offset: '0.352055',
    stopColor: '#690DC1'
  }), React.createElement("stop", {
    offset: '0.41767',
    stopColor: '#6312C4'
  }), React.createElement("stop", {
    offset: '0.482348',
    stopColor: '#5C18C7'
  }), React.createElement("stop", {
    offset: '0.54637',
    stopColor: '#541FCA'
  }), React.createElement("stop", {
    offset: '0.610022',
    stopColor: '#4C27CE'
  }), React.createElement("stop", {
    offset: '0.673586',
    stopColor: '#422FD2'
  }), React.createElement("stop", {
    offset: '0.737345',
    stopColor: '#3738D7'
  }), React.createElement("stop", {
    offset: '0.801582',
    stopColor: '#2C42DC'
  }), React.createElement("stop", {
    offset: '0.866582',
    stopColor: '#204DE1'
  }), React.createElement("stop", {
    offset: '0.932627',
    stopColor: '#1358E7'
  }), React.createElement("stop", {
    offset: '1',
    stopColor: '#0564ED'
  })), React.createElement("radialGradient", {
    id: 'paint1_radial_1369_28173',
    cx: '0',
    cy: '0',
    r: '1',
    gradientUnits: 'userSpaceOnUse',
    gradientTransform: 'translate(10.9272 4.00899) rotate(74.8737) scale(34.2612 83.814)'
  }, React.createElement("stop", {
    stopColor: '#F5EBFA'
  }), React.createElement("stop", {
    offset: '0.161458',
    stopColor: '#EEDEF6',
    stopOpacity: '0.864583'
  }), React.createElement("stop", {
    offset: '0.333333',
    stopColor: '#E8D2F3',
    stopOpacity: '0.735701'
  }), React.createElement("stop", {
    offset: '0.661458',
    stopColor: '#D1A8E8',
    stopOpacity: '0.290563'
  }), React.createElement("stop", {
    offset: '0.822917',
    stopColor: '#C999E4',
    stopOpacity: '0.137944'
  }), React.createElement("stop", {
    offset: '1',
    stopColor: '#C28CE0',
    stopOpacity: '0'
  })), React.createElement("radialGradient", {
    id: 'paint2_radial_1369_28173',
    cx: '0',
    cy: '0',
    r: '1',
    gradientUnits: 'userSpaceOnUse',
    gradientTransform: 'translate(61.0927 67.1506) rotate(-120.035) scale(20.8387 46.6438)'
  }, React.createElement("stop", {
    stopColor: '#E8F2FF'
  }), React.createElement("stop", {
    offset: '0.0001',
    stopColor: '#E8F2FF'
  }), React.createElement("stop", {
    offset: '1',
    stopColor: '#99C3F9',
    stopOpacity: '0'
  }))));
}